/**
 * 앱 로그 목록 (/adm/app/logs) — 앱이 올린 로그 파일 목록, 행을 누르면 뷰어 창
 * ($j.Pages.Admin.AppLogs / body data-page-name="AppLogs")
 */
export default class AppLogs {
    initialize() {
        const DEF_START = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
        const DEF_END   = dayjs().format('YYYY-MM-DD');

        $('#start_date').val(DEF_START);
        $('#end_date').val(DEF_END);
        $('#start_date, #end_date').mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            buttons: [],  // 설정 버튼 제거
        });

        let $table = null;

        $(function () {
            // 검색 — 폼 전송(엔터·버튼)은 막고 search() 로 (예전 onsubmit="search(); return false;")
            $('#searchForm').on('submit', (e) => { e.preventDefault(); search(); });
            loadTable();

            $('#page_length').on('change', function () {
                $table.page.len(parseInt(this.value, 10)).draw();
            });

            $('#resetBtn').on('click', function () {
                $('#start_date').val(DEF_START);
                $('#end_date').val(DEF_END);
                $('#serchLogType').val('co.kr.jbbuller');
                $('#find-user-kwd').val('');
                $('#page_length').val('20');
                $table.page.len(20);
                search();
            });
        });

        /**
         * 테이블 데이터 tr 내용
         */
        function loadTable() {
            // 정렬은 컬럼 머리를 눌러서 한다 — 서버는 columns[i].data 로 온 키를
            // 화이트리스트에 대조한다 (AppLogService::SORTABLE).
            const columns = [
                {data: 'rnum',    title: 'No.', orderable: false},
                // 회원 표기는 관리자 공용 규약 — `이름#번호` + 회원 팝오버.
                // 옛 $j.F.Admin.Util.userOrder(모바일 알림창) 은 팝오버 안의 줄로 들어가 있다
                {data: null, title: '회원', render: (d, t, r) => $j.F.Admin.Member.Pop.cell(r.mb_no, r.mem_name)},
                {data: 'package', title: '앱 패키지명'},
                {data: 'ver',     title: '앱 버전'},
                {data: 'wv_ver',  title: '웹뷰 버전'},
                {data: 'regdate', title: '등록일'},
                {data: 'url',     title: '다운로드', orderable: false, render: () => `<button class="btn btn-sm btn-outline-primary btn-download">다운로드</button>`},
            ];

            if ($table) {
                $table.destroy();
                $('#table').empty();  // 테이블 내용을 비워서 초기화
            }

            $table = new DataTable('#table', {
                columns: columns,
                rowCallback: formatRow,
                headerCallback: (thead) => $(thead).find('th').css('text-align', 'center'),
                ajax: {
                    url: '/adm/ajax/config/logs',
                    type: 'post',
                    data: (d) => {
                        d.findUserKwd  = $('#find-user-kwd').val();
                        d.serdayst     = $('#start_date').val();
                        d.serdayen     = $('#end_date').val();
                        d.serchLogType = $('#serchLogType').val();
                    },
                },
                processing: true,
                serverSide: true,
                ordering: true,
                order: [[5, 'desc']],     // 등록일 최신순
                displayLength: 20,
                lengthChange: false,      // 목록수는 위 검색영역에서 고른다
                searching: false
            });

            $table.on('click', 'tr', function (e) {
                const data = $table.row(this).data();
                if (!data) return;
                let columnIndex = $(e.target).closest('td').index();

                // 회원번호 컬럼 클릭 시 무시
                if (columnIndex === 1) {
                    e.stopPropagation();
                    return;
                }

                // 다운로드 버튼 클릭 시
                if ($(e.target).hasClass('btn-download')) {
                    downloadLogFile(data);
                    e.stopPropagation();
                    return;
                }

                // 그 외 컬럼 클릭 시 뷰어 팝업
                let _width = 1000;
                let _height = 700;
                let xPos = (document.body.offsetWidth / 2) - (_width / 2);
                xPos += window.screenLeft;

                const viewParams = new URLSearchParams({
                    url: data['url'],
                    regdate: data['regdate'],
                    package: data['package'],
                    ver: data['ver'],
                    mb_no: data['mb_no']
                });
                window.open('/adm/app/logs/view?' + viewParams.toString(), "log_popup", "width=" + _width + ", height=" + _height + ", left=" + xPos + ", menubar=yes, status=yes, titlebar=yes, resizable=yes");
                e.stopPropagation();
            });
        }

        /** 앱별로 줄 배경을 나눈다 — 두 앱 로그가 한 표에 섞여 나온다 */
        function formatRow(row, data) {
            $(row).find('td').addClass(
                data['package'] === 'co.kr.badcall' ? 'cr-background-red' : 'cr-background-white'
            );
        }

        /**
         * 인풋 데이터로 검색
         */
        function search() {
            $table.ajax.reload();
        }

        function makeLogFilename(data) {
            const d = new Date(data['regdate'] || '');
            const year = String(d.getFullYear()).slice(2);
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${data['mb_no']}(${year}-${month}-${day}).txt`;
        }

        function downloadLogFile(data) {
            fetch(data['url'])
                .then(res => res.blob())
                .then(blob => {
                    const a = document.createElement('a');
                    a.href = URL.createObjectURL(blob);
                    a.download = makeLogFilename(data);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(a.href);
                });
        }

        // 회원 검색칸 — '이름#번호' 규약 (숨은 상태 없음)
        $j.F.Admin.Util.memberSearch('find-user-kwd');
    }
}
